module.exports = __webpack_public_path__ + "static/awasul_screens_stack_3-bbd2084fea024f601bd609dad9ad4709.png";